import React, {
  useState,
} from 'react';

import {
  toast,
} from 'react-toastify';

import * as S from './styled';

type Props = {
  src: string,
  preview: string,
};

const Video = ({ src, preview }: Props) => {
  const [isPlaying, setPlay] = useState<boolean>(false);
  return (
    <S.Video>
      {isPlaying ? (
        <S.Frame
          src={`${src}?autoplay=1`}
          allowFullScreen
        />
      ) : (
        <S.Preview
          style={preview
            ? { backgroundImage: `url(${preview})` }
            : {}}
        >
          <S.PlayIcon onClick={() => (src ? setPlay(true) : toast.error('Error.'))}>
            <S.Play />
          </S.PlayIcon>
        </S.Preview>
      )}
    </S.Video>
  );
};

export default Video;
